var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "legend" },
    [
      _c("el-tag", { attrs: { type: "primary", size: "small" } }, [
        _c("i", { staticClass: "el-icon-loading" }),
        _vm._v(" " + _vm._s(_vm.$t("Pending")) + " ")
      ]),
      _c("el-tag", { attrs: { type: "warning", size: "small" } }, [
        _c("i", { staticClass: "el-icon-loading" }),
        _vm._v(" " + _vm._s(_vm.$t("Running")) + " ")
      ]),
      _c("el-tag", { attrs: { type: "success", size: "small" } }, [
        _c("i", { staticClass: "el-icon-check" }),
        _vm._v(" " + _vm._s(_vm.$t("Finished")) + " ")
      ]),
      _c("el-tag", { attrs: { type: "danger", size: "small" } }, [
        _c("i", { staticClass: "el-icon-error" }),
        _vm._v(" " + _vm._s(_vm.$t("Error")) + " ")
      ]),
      _c("el-tag", { attrs: { type: "info", size: "small" } }, [
        _c("i", { staticClass: "el-icon-video-pause" }),
        _vm._v(" " + _vm._s(_vm.$t("Cancelled")) + " ")
      ]),
      _c("el-tag", { attrs: { type: "danger", size: "small" } }, [
        _c("i", { staticClass: "el-icon-warning" }),
        _vm._v(" " + _vm._s(_vm.$t("Abnormal")) + " ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }